import { CountryCode, CountryLabel, type IsoLocale, Locale } from './types'

export type CountryData = {
  id: CountryLabel
  countryCode: CountryCode
  defaultLocale: IsoLocale
  locales: Array<IsoLocale>
  currencyCode: string
}

export const countries: Record<CountryLabel, CountryData> = {
  [CountryLabel.SE]: {
    id: CountryLabel.SE,
    countryCode: CountryCode.Se,
    defaultLocale: Locale.SvSe,
    locales: [Locale.SvSe, Locale.EnSe],
    currencyCode: 'SEK',
  },
  [CountryLabel.NO]: {
    id: CountryLabel.NO,
    countryCode: CountryCode.No,
    defaultLocale: Locale.NoNo,
    locales: [Locale.NoNo, Locale.EnNo],
    currencyCode: 'NOK',
  },
  [CountryLabel.DK]: {
    id: CountryLabel.DK,
    countryCode: CountryCode.Dk,
    defaultLocale: Locale.DaDk,
    locales: [Locale.DaDk, Locale.EnDk],
    currencyCode: 'DKK',
  },
}
